"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const droits_1 = require("views/droits");
const globals_1 = require("models/globals");
class DroitsConcepteur extends droits_1.default {
    constructor(app, name) {
        super(app, name, {
            columnData: [
                { id: "unid", name: "unid", header: (0, globals_1._)("#"), width: 50 },
                { id: "parentId", name: "parentId", header: "", width: 50 },
                { id: "previousId", editor: "text", header: "", width: 50 },
                { id: "libelle", editor: "text", header: (0, globals_1._)("Libellé"), width: 200,
                    template: "{common.treetable()} #libelle#" },
                { id: "accessType", editor: "select", header: (0, globals_1._)("Type"), width: 120, options: [
                        { "id": "Menu", "value": (0, globals_1._)("Menu") },
                        { "id": "Fonction", "value": (0, globals_1._)("Fonction") }
                    ]
                },
                { id: "description", editor: "text", header: (0, globals_1._)("Description"), width: 500 },
                { id: "accessKey", editor: "text", header: (0, globals_1._)("Clé"), width: 200, sort: "text" },
                { id: "administrateur", template: "{common.checkbox()}", header: (0, globals_1._)("Admin"), width: 80, value: "0",
                    uncheckValue: "0", checkValue: "1" },
                { id: "editeur", template: "{common.checkbox()}", header: (0, globals_1._)("Editeur"), width: 80, value: "0", uncheckValue: "0", checkValue: "1" },
                { id: "lecteur", template: "{common.checkbox()}", header: (0, globals_1._)("Lecteur"), width: 80, value: "0", uncheckValue: "0", checkValue: "1" }
            ],
        });
    }
    init() {
        this.moduleName = "droitsC";
        super.init();
        // @ts-ignore
        this.$$("title").setHTML("Droits d'accès Concepteur");
        if ((globals_1.lv2.droits).includes(this.moduleName + ".insert,")) { // @ts-ignore
            this.$$("button-add").show();
        }
        if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,")) { // @ts-ignore
            this.$$("button-delete").show();
        }
    }
}
exports.default = DroitsConcepteur;
